module.exports = __webpack_public_path__ + "img/technology-3.5ab6b690.png";